import React, { lazy } from 'react';
const bonuses = [{
  title: 'Die Notfall-Box',
  desc: '30 fertige Einheiten für Tage mit 0 Min. Vorbereitung. Seite schnappen. Selbstbewusst in die Halle gehen.',
  value: '80 €',
  img: 'https://cdn.magicpatterns.com/uploads/1BPGN7dhYbMeiMFcCkYbjB/61630845-0899-4ebe-a133-c7064c14b9dc-mockup.webp'
}, {
  title: '30 Motivations-Drills',
  desc: 'Spiele, die jede Klasse sofort aktivieren. Ohne viel Material, überall und mit jeder Gruppengröße durchführbar.',
  value: '100 €',
  img: 'https://cdn.magicpatterns.com/uploads/bFG6H5XEiefVh8BTrbkFdg/e6ebbe28-2f65-4604-9e42-353706e5c466-mockup.webp'
}, {
  title: 'Das Bewertungssystem',
  desc: 'Pädagogische Bewertungsbögen & Notenhilfen, um Fähigkeiten und Einsatz ohne Papierchaos zu tracken.',
  value: '70 €',
  img: 'https://cdn.magicpatterns.com/uploads/sxLfA1AMM6BG8QAa4rkRdr/f0a119c3-37df-4fca-a2d1-031f2e856ed1-mockup.webp'
}, {
  title: 'Der 4-Wochen-Schnellstart',
  desc: 'Von Null auf Spielbereit für neue Gruppen. Die perfekte Struktur für die ersten Wochen.',
  value: '90 €',
  img: 'https://cdn.magicpatterns.com/uploads/xvNZ6xMNGbenySeQVd1h7o/8ea862a0-b0ab-4806-8f46-19aafd0b6d4c-mockup.webp'
}, {
  title: 'Der Zeitspar-Baukasten',
  desc: 'Profi-Hacks für das Klassenmanagement, um jede Woche 5 Stunden zurückzugewinnen und wie ein Profi zu unterrichten.',
  value: '60 €',
  img: 'https://cdn.magicpatterns.com/uploads/uS4SxzhLLLohhTDzKnZVCa/4d7961bb-18e8-4153-9b45-b8b8ace37fa2-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 HEUTE GRATIS:{' '}
            <span className="text-[#FF6B00]" data-id="element-5">
              5 strategische Boni inklusive
            </span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium mb-5" data-id="element-6">
            Ohne zusätzliche Kosten enthalten
          </p>
          <span className="inline-flex items-center gap-2 bg-[#16161F] border border-[#FF6B0033] rounded-full px-5 py-2.5 text-sm sm:text-base font-bold" data-id="element-7">
            <span className="text-[#B0B0C0]" data-id="element-8">Echter Wert:</span>
            <span className="text-[#FF6B00] line-through" data-id="element-9">400 €</span>
            <span className="text-[#B0B0C0]" data-id="element-10">— heute inklusive</span>
            <span className="text-[#00C853] font-black uppercase tracking-wider" data-id="element-11">
              KOSTENLOS
            </span>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl p-5 flex flex-col" data-id="element-13">
              <div className="relative mb-4 rounded-xl overflow-hidden bg-[#0A0A0A]" data-id="element-14">
                <img src={bonus.img} alt={bonus.title} loading="lazy" className="w-full aspect-square object-cover" width={1024} height={1024} data-id="element-15" />
              </div>
              <div className="flex items-center justify-between mb-3" data-id="element-16">
                <span className="inline-flex items-center gap-1.5 bg-[#FF6B00] text-white font-black text-xs sm:text-sm tracking-wider uppercase px-3 py-1.5 rounded-lg shadow-[0_4px_14px_rgba(255,107,0,0.4)]" data-id="element-17">
                  🎁 Bonus 0{i + 1}
                </span>
                <span className="inline-flex items-center gap-1.5 bg-[#00C853]/10 text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-18">
                  <span className="text-[#FF6B00] line-through" data-id="element-19">
                    {bonus.value}
                  </span>
                  <span className="text-[#00C853]" data-id="element-20">KOSTENLOS</span>
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-21">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-22">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}